const answerTemplate = `<answer fraction="100" format="html">
<text><![CDATA[%answer_text]]></text>
<feedback format="html">
    <text></text>
</feedback>
</answer>`;

export default answerTemplate;
